import React from 'react';
import { CheckoutCta } from './CheckoutCta';
export function ClosingCta() {
  return <section aria-labelledby="closing-title" className="bg-gradient-to-br from-[#B79DE0] to-[#9579CC] py-16 text-white md:py-20" data-id="element-52" data-mp="r93pi87qqxca">
      <div className="mx-auto max-w-xl px-5 text-center" data-id="element-53" data-mp="mh3jpz4zpa7s">
        <h2 id="closing-title" className="font-serif text-[1.9rem] font-bold leading-tight [font-style:normal] md:text-4xl" data-id="element-54" data-mp="hj227in7piyf">
          Továbbra is az utolsó helyre teheted azt, amit érzel.
          <span className="mt-2 block" data-id="element-55" data-mp="8idjwbqscwfq">Vagy már ma elkezdhetsz egy kis időt szánni magadra.</span>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/90" data-id="element-56" data-mp="3j0ylvfkbxf9">
          Megérdemelsz egy nyugodt pillanatot. Nem kell tudnod rajzolni: válassz egyet a több mint 150 vezetett tevékenység
          közül, szánj rá tíz percet, és fejezd ki a művészet segítségével azt, amit szavakkal nem mindig sikerül elmondani.
        </p>

        <div className="mt-8" data-id="element-57" data-mp="1sz8t7stde0hp">
          <CheckoutCta tone="light" data-id="element-58" data-mp="1sz0gq215sx71" />
        </div>

        <p className="mt-5 text-[15px] font-semibold leading-relaxed text-white/90" data-id="element-59" data-mp="kawyc90l28uy">
          🎁 6 ajándék bónusz · 🆕 2. kiadás 100 új tevékenységgel · 🛡️ 30 napos garancia · ⚡ Azonnali hozzáférés
        </p>
      </div>
    </section>;
}